import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import './CategoryBreakdown.css';

const COLORS = ['#c8102e','#00205b','#27ae60','#f39c12','#9b59b6','#3498db','#e67e22'];

function CategoryBreakdown({ data }) {
  const chartData = data.map((item, i) => ({
    name: item.category,
    value: item.projects,
    budget: item.budget || 0,
    beneficiaries: item.beneficiaries || 0,
    color: COLORS[i % COLORS.length]
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const d = payload[0].payload;
      return (
        <div className="cat-tooltip">
          <p className="cat-tooltip-title">{d.name}</p>
          <p>Projects: <strong>{d.value}</strong></p>
          <p>Beneficiaries: <strong>{d.beneficiaries.toLocaleString()}</strong></p>
        </div>
      );
    }
    return null;
  };

  if (!chartData.length) {
    return <div className="no-data">No category data available</div>;
  }

  return (
    <div className="category-breakdown">
      <ResponsiveContainer width="100%" height={240}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={100}
            dataKey="value"
            label={({ name, percent }) =>
              `${name} ${(percent * 100).toFixed(0)}%`
            }
            labelLine={false}
          >
            {chartData.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>

      <div className="cat-legend">
        {chartData.map((item, i) => (
          <div key={i} className="cat-legend-item">
            <div className="cat-dot" style={{ background: item.color }} />
            <span className="cat-name">{item.name}</span>
            <span className="cat-count">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoryBreakdown;
